import { TextBox } from '@apply/components';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface PaintingSidingWallFinishDescriptionProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const PaintingSidingWallFinishDescription: React.FC<PaintingSidingWallFinishDescriptionProps> = ({
    required,
    readOnly,
    propertyGuid,
    isReview = false,
}) => {
    const [paintingSidingWallFinish, set_paintingSidingWallFinish] = useBudgetFixFlipField<string>(
        propertyGuid,
        (b) => (b.values?.['Exterior Structure']?.['Painting, Siding, Wall Finish']?.[0] as string) ?? '',
        (b, v) => ({ ...b, values: { ...b.values, 'Exterior Structure': { ...b.values?.['Exterior Structure'], 'Painting, Siding, Wall Finish': [v, b.values?.['Exterior Structure']?.['Painting, Siding, Wall Finish']?.[1] ?? 0] as [string, number] } } })
    );
    const label = 'Description';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={paintingSidingWallFinish}
                />
            ) : (
                <TextBox
                    value={paintingSidingWallFinish}
                    onChange={(value) => set_paintingSidingWallFinish(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
